import { render, staticRenderFns } from "./CustomerRatings.vue?vue&type=template&id=249c5a90"
import script from "./CustomerRatings.vue?vue&type=script&lang=js"
export * from "./CustomerRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249c5a90')) {
      api.createRecord('249c5a90', component.options)
    } else {
      api.reload('249c5a90', component.options)
    }
    module.hot.accept("./CustomerRatings.vue?vue&type=template&id=249c5a90", function () {
      api.rerender('249c5a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerRatings.vue"
export default component.exports